import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const CatalogFilters = ({
  filters,
  sortConfig,
  counts = { ready: 0, order: 0, sources: {} },
  onFilterChange,
  onSortClick,
  onRecommendedClick,
  onResetFilters,
  productSources
}) => {
  const serviceTypes = [
    { dbValue: 'ready', displayValue: 'Ready Serve', count: counts.ready },
    { dbValue: 'order', displayValue: 'Order Serve', count: counts.order }
  ];

  return (
    <div className="catlogwrapper">
      {/* Service Type Buttons */}
      <div className="service-buttons">
        {serviceTypes.map(service => (
          <div
            key={service.dbValue}
            className={`service-btn ${(filters.serviceType || 'ready') === service.dbValue ? 'active' : ''}`}
            onClick={() => onFilterChange('serviceType', service.dbValue)}
          >
            {service.displayValue} ({service.count ?? 0})
          </div>
        ))}
      </div>

      {/* Source Buttons */}
      <div className="filter-buttons">
        {productSources.map(source => {
          const sourceCount = counts.sources?.[source] ?? 0;
          return (
            <button
              key={source}
              className={`filter-btn ${filters.productSource === source ? 'active' : ''}`}
              onClick={() => onFilterChange('productSource', source)}
            >
              {source} ({sourceCount})
            </button>
          );
        })}
      </div>

      {/* Sort Buttons */}
      <div className="sort-buttons">
        <button
          className={`sort-btn ${sortConfig.field === '' ? 'active' : ''}`}
          onClick={onRecommendedClick}
        >
          Recommended
        </button>

        <button
          className={`sort-btn ${sortConfig.field === 'weight' ? 'active' : ''}`}
          onClick={() => onSortClick('weight')}
        >
          Weight
          {sortConfig.field === 'weight' && (
            sortConfig.direction === 'desc' ? <ChevronDown size={16} /> : <ChevronUp size={16} />
          )}
        </button>

        <button
          className={`sort-btn ${sortConfig.field === 'wastage' ? 'active' : ''}`}
          onClick={() => onSortClick('wastage')}
        >
          Wastage
          {sortConfig.field === 'wastage' && (
            sortConfig.direction === 'desc' ? <ChevronDown size={16} /> : <ChevronUp size={16} />
          )}
        </button>
      </div>
    </div>
  );
};

export default CatalogFilters;